import { createAction } from "@coverme/redux";
import Axios from "axios";

export const getCounties = () =>
    createAction("GET_COUNTIES", () => Axios.get("/api/jurisdictions/counties").then(data => data.data));
